import React, { Component } from "react";
import { Button, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { CardElement, Elements, injectStripe, StripeProvider } from "react-stripe-elements";

import { BeautifulDialog, ShowErrorDialog } from "js/react/components/Dialogs/BaseDialog";
import Api from "js/core/api";
import getLogger, { LogGroup } from "js/core/logger";

import "css/billing.scss";

const logger = getLogger(LogGroup.BILLING);

class Dialog extends Component {
    state = {
        isSubmitting: false,
        error: null
    };

    handleUpdatePaymentMethod = async orgId => {
        if (this.state.isSubmitting) return;

        this.setState({ isSubmitting: true });
        const card = await this.props.stripe.createPaymentMethod("card");
        if (card.error) {
            this.setState({ isSubmitting: false });
            logger.error(card.error, "stripe.createPaymentMethod() failed", { orgId });
            return;
        }

        const paymentMethod = card.paymentMethod;
        try {
            await Api.paymentMethods.post({
                payment_method_id: paymentMethod.id,
                organization_id: orgId
            });
        } catch (err) {
            logger.error(err, "Api.paymentMethods.post() failed", { paymentMethodId: paymentMethod.id, orgId });
            ShowErrorDialog({
                error: "Could not change payment method",
                message: err.message
            });
        }
        this.props.closeDialog();
        this.props.callback && this.props.callback();
    };

    render() {
        return (
            <BeautifulDialog className="update_payment_form" closeDialog={this.props.closeDialog}>
                <DialogTitle>Update Payment Method</DialogTitle>
                <DialogContent>
                    <CardElement
                        onChange={event => {
                            if (event.error) {
                                this.setState({
                                    error: event.error.message
                                });
                            } else {
                                this.setState({ error: null });
                            }
                        }}
                    />
                    {this.state.error && <div className="card-error">{this.state.error}</div>}
                </DialogContent>
                <DialogActions>
                    <Button color="secondary" onClick={this.props.closeDialog}>
                        Cancel
                    </Button>
                    <Button color="primary" onClick={() => this.handleUpdatePaymentMethod(this.props.orgId)}>
                        Update Payment Method
                    </Button>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}

const InjectedChangePaymentMethodDialog = injectStripe(Dialog);

class ChangePaymentMethodDialog extends Component {
    render() {
        return (
            <StripeProvider apiKey={window.stripePublishableKey}>
                <Elements>
                    <InjectedChangePaymentMethodDialog {...this.props} />
                </Elements>
            </StripeProvider>
        );
    }
}

export default ChangePaymentMethodDialog;
